import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavActionsDirective, SidenavCloseDirective, SidenavContentDirective, SidenavLabelDirective, SidenavTitleDirective } from './sidenav-content.directive';

const SIDENAV_CONTENT_DIRECTIVES = [
    SidenavContentDirective,
    SidenavTitleDirective,
    SidenavLabelDirective,
    SidenavActionsDirective,
    SidenavCloseDirective,
];

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations:[
        ...SIDENAV_CONTENT_DIRECTIVES,
    ],
    exports: [
        ...SIDENAV_CONTENT_DIRECTIVES,
    ],
})
export class SidenavContentModule
{
}
